import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser, checkAuth } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    (async () => {
      const hash = window.location.hash || "";
      const m = hash.match(/session_id=([^&]+)/);
      if (!m) { nav("/login", { replace: true }); return; }
      const session_id = decodeURIComponent(m[1]);
      try {
        const { data } = await api.post("/auth/session", { session_id });
        setUser(data.user);
        // Clean URL fragment
        window.history.replaceState({}, "", window.location.pathname);
        // Verify cookie roundtrip with /auth/me before navigating away.
        // This prevents a race where SelectRole/AppShell renders while context.user is still null.
        await checkAuth();
        if (!data.user.role) {
          nav("/onboarding", { replace: true });
        } else {
          nav("/app", { replace: true });
        }
      } catch (e) {
        console.error("Auth callback failed:", e);
        nav("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="font-heading text-lg font-semibold">Signing you in…</div>
        <div className="text-xs text-muted-foreground mt-1">Establishing secure session</div>
      </div>
    </div>
  );
}
